var DESKTOP_EXPANDED_MAX_WIDTH = '358px';
export var searchBarTheme = {
  baseStyle: _ref => {
    var {
      hasValue,
      isFullWidth
    } = _ref;
    return {
      container: {
        display: 'flex',
        height: '40px',
        isolation: 'isolate',
        position: 'relative',
        borderBottom: 'none',
        borderRadius: 'full',
        border: 'basic.light',
        width: '100%',
        maxWidth: {
          xs: '100%',
          s: isFullWidth ? '100%' : hasValue ? DESKTOP_EXPANDED_MAX_WIDTH : '250px'
        },
        transition: 'max-width 0.4s ease-in-out, border 0.1s ease-in-out, color 0.1s ease-in-out',
        bg: 'neutral.white',
        color: 'neutral.darker',
        paddingX: 's',
        paddingY: 'xs',
        _hover: {
          border: 'basic.dark',
          color: 'neutral.darkest',
          cursor: 'text'
        },
        _focus: {
          maxWidth: {
            xs: '100%',
            s: isFullWidth ? '100%' : DESKTOP_EXPANDED_MAX_WIDTH
          },
          color: 'neutral.black',
          outlineOffset: '2px',
          outlineWidth: '2px',
          outlineStyle: 'solid',
          outlineColor: 'focus.focus'
        },
        _disabled: {
          border: 'basic.light',
          color: 'neutral.light',
          cursor: 'not-allowed'
        }
      },
      field: {
        height: '100%',
        width: '100%',
        padding: 'none',
        borderBottom: 'none',
        position: 'relative',
        color: 'neutral.black',
        textStyle: 'body2',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        _placeholder: {
          color: 'neutral.dark'
        },
        _hover: {
          borderBottom: 'none'
        },
        _focus: {
          borderBottom: 'none'
        },
        _disabled: {
          borderBottom: 'none',
          color: 'neutral.light',
          pointerEvents: 'none',
          _placeholder: {
            color: 'neutral.light'
          }
        }
      }
    };
  }
};
//# sourceMappingURL=SearchBar.theme.js.map